// extracted by mini-css-extract-plugin
export var formContainer = "_mp-0";
export var message = "_mp-1";